// TODO: Remove this file after 2027-07-01 when the FY-to-CY transition is complete.
// At that point, getQuarterLabel() in status-machine.ts can drop the year parameter
// and getQuarterOptions() callers can switch back to static options.

/**
 * During the FY2026-27 to CY2027 transition, returns a fiscal year quarter label
 * to display alongside the CY quarter. Returns null when not in the transition period.
 *
 * Hillsdale's fiscal year runs Jul-Jun. The FY2026-27 year is the last fiscal year
 * before switching to calendar year on 1/1/2027.
 *
 * Mapping (FY runs Jul-Jun):
 *   Q3 2026 -> "FY Q1"    Q1 2027 -> "FY Q3"
 *   Q4 2026 -> "FY Q2"    Q2 2027 -> "FY Q4"
 */

const FY_LABELS: Record<string, Record<string, string>> = {
  "2026": {
    Q3: "FY Q1",
    Q4: "FY Q2",
  },
  "2027": {
    Q1: "FY Q3",
    Q2: "FY Q4",
  },
};

export function getFiscalLabel(quarter: string, year: number): string | null {
  return FY_LABELS[String(year)]?.[quarter] ?? null;
}

const CY_QUARTER_LABELS: Record<string, string> = {
  Q1: "Jan\u2013Mar",
  Q2: "Apr\u2013Jun",
  Q3: "Jul\u2013Sep",
  Q4: "Oct\u2013Dec",
};

const QUARTERS = ["Q1", "Q2", "Q3", "Q4"] as const;

/**
 * Returns quarter select options with FY labels appended during the transition period.
 * Accepts an optional year; when omitted, returns CY-only labels.
 */
export function getQuarterOptions(year?: number): { value: string; label: string }[] {
  return QUARTERS.map((q) => {
    const cyLabel = `${q} (${CY_QUARTER_LABELS[q]})`;
    if (year == null) return { value: q, label: cyLabel };
    const fyLabel = getFiscalLabel(q, year);
    return {
      value: q,
      label: fyLabel ? `${cyLabel} \u00B7 ${fyLabel}` : cyLabel,
    };
  });
}
